// eslint-disable-next-line import/no-anonymous-default-export
export default function () {
  onmessage = (event) => {
    const { runData, finishLineGeoJson } = event.data;

    // Helper function to check if two line segments intersect
    const doLineSegmentsIntersect = (p0, p1, p2, p3) => {
      const s1_x = p1[0] - p0[0];
      const s1_y = p1[1] - p0[1];
      const s2_x = p3[0] - p2[0];
      const s2_y = p3[1] - p2[1];

      const s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
      const t = (s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);

      return s >= 0 && s <= 1 && t >= 0 && t <= 1;
    };

    const checkCrossFinishLine = (startPoint, endPoint, finishLineCoordinates, index) => {
      const [finishLineStart, finishLineEnd] = finishLineCoordinates;
      const crosses = doLineSegmentsIntersect(startPoint, endPoint, finishLineStart, finishLineEnd);

      if (crosses) {
        console.log(
          'finishLineWorker / index', index,
          ' / startPoint', startPoint,
          ' / endPoint', endPoint,
          ' / result', crosses
        );
      }

      return crosses;
    };

    const finishTimes = [];
    if (runData) {
      console.log('finishLineWorker / start');
      console.log('finishLineWorker / runData', runData);
      console.log('finishLineWorker / finishLineGeoJson', finishLineGeoJson);

      if (finishLineGeoJson) {
        const finishLineCoordinates = finishLineGeoJson.geometry.coordinates;

        for (let i = 0; i < runData.length - 1; i++) {
          const startPoint = [runData[i].positionGps_longitude, runData[i].positionGps_latitude];
          const endPoint = [runData[i + 1].positionGps_longitude, runData[i + 1].positionGps_latitude];
          if (checkCrossFinishLine(startPoint, endPoint, finishLineCoordinates, i)) {
            console.log('finishLineWorker / segment valid', runData[i]);
            finishTimes.push({ timePosition: i });
          }
        }
      }

      console.log('finishLineWorker / end');
    }

    postMessage({ finishTimes });
  };
}
